module.exports = __webpack_public_path__ + "34e7b47b4e882d78fb3669e7c1460502.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/practice-question-2.png
// module id = 1749
// module chunks = 0